import { render, staticRenderFns } from "./Resume.vue?vue&type=template&id=6edbb9a8&scoped=true"
import script from "./Resume.vue?vue&type=script&lang=js"
export * from "./Resume.vue?vue&type=script&lang=js"
import style0 from "./Resume.vue?vue&type=style&index=0&id=6edbb9a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edbb9a8",
  null
  
)

export default component.exports